import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { MyCheckbox } from '../../MyCheckbox';
import { Hoverable } from 'react-native-web-hover';
import TooltipWrapper from '../../TooltipWrapper';

interface Props {
    label: string;
    value: boolean;
    onChange: (value: boolean) => void;
    showTooltip?: boolean;
    tooltipText?: string;
    zIndex?: number;
    onTooltipHovered?: (hovered: boolean) => void;
    disabled?: boolean;
}

function FilterCheckBox({ label, value, onChange, showTooltip, tooltipText, zIndex, onTooltipHovered, disabled }: Props) {
    const { styles } = useStyles(stylesheet);

    return (
        <View style={[styles.inputContainer, zIndex ? { zIndex } : undefined]}>
            <View style={styles.tooltipWrapper}>
                <MyCheckbox
                    checkBoxStyle={styles.checkbox}
                    textStyle={styles.filterText}
                    label={label}
                    checked={value}
                    setChecked={onChange}
                    disabled={disabled}
                />
                {showTooltip && tooltipText && <Hoverable>
                    {({ hovered }) => (
                        <TooltipWrapper
                            hovered={hovered}
                            onTooltipHovered={onTooltipHovered}
                            tooltipText={tooltipText}
                        />
                    )}
                </Hoverable>}
            </View>
        </View>
    );
}

const stylesheet = createStyleSheet(theme => ({
    inputContainer: {
        minWidth: 200,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5
    },

    filterText: {
        color: theme.colors.labelColor,
        fontSize: 16,
        height: 25,
    },
    checkbox: {
        width: 20,
        height: 20
    },
    tooltipWrapper: {
        flexDirection: 'row',
        gap: 5,
        alignItems: 'center'
    },
}));

export default FilterCheckBox;
